import dayjs from 'dayjs';
import { BlockedInfo, NfcCard, NfcCardAssignment } from 'graphql/generated/graphqlTypes';

export function generateMockNfcCard({
  assignment = null,
  name = 'mockedNfcCardName',
  updateRequired = false,
  uuid = 'mockedNfcCardUuid'
}: Partial<Omit<NfcCard, '__typename'>>): NfcCard {
  return {
    __typename: 'NfcCard',
    assignment,
    name,
    updateRequired,
    uuid
  };
}

export function generateMockNfcCardAssignment({
  blocked = null,
  expired = false,
  expiryDate = dayjs().toISOString(),
  visitor = null,
  visitorName = 'mockVisitorName'
}: Partial<Omit<NfcCardAssignment, '__typename'>>): NfcCardAssignment {
  return {
    __typename: 'NfcCardAssignment',
    blocked,
    expired,
    expiryDate,
    visitor,
    visitorName
  };
}

export function generateMockNfcCardAssignmentBlockedInfo({
  reason = '',
  since = dayjs().toISOString()
}: Partial<Omit<BlockedInfo, '__typename'>>): BlockedInfo {
  return {
    __typename: 'BlockedInfo',
    reason,
    since
  };
}
